export default {
	columns: {
		roleName: {
			label: '角色名称',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		useNumber: {
			label: '应用账号',
			visible: true,
			width: 'auto',
			align: 'center',
		},
	},
}
